// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__GLHWA","l4":"styles_l4__TqE4v"};